import React from 'react';
import {SubHeading, MenuItem} from '../../components';
import {images, data} from '../../constants';
import {BsInstagram} from 'react-icons/bs';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Autoplay, Pagination} from 'swiper';
import { motion} from 'framer-motion'
// Import Swiper styles
import 'swiper/css/bundle'

const galleryimages = [images.gallery01, images.gallery02, images.gallery03, images.gallery04]

const Gallery = () => {

    return (
        <div className="gallery w-full h-screen flex flex-col bg-black py-16" id='gallery'>

            <motion.div
               whileInView={{
                        scale: [
                            0, 1
                        ],
                        opacity: [0, 1]
                    }}
                    transition={{
                        duration: 0.8,
                        type: 'spring'
                    }}


                className="m-auto w-[80%] flex flex-col md:flex-row  justify-between items-center">
                <div className='basis-[100%] md:basis-[50%] mb-6'>
                    <SubHeading title="Instagram"/>
                    <h1 className='text-yellow-200 text-5xl font-semibold font-main'>Photo Gallery</h1>
                    <p className='text-[#aaa] mt-8 font-submain'>Check out some of our eye catching dishes on Instagram</p>
                    <button type='button' className='bg-yellow-200 rounded-md mt-4 p-2'>View More</button>
                </div>
                <motion.div
                   whileInView={{
                        scale: [
                            0, 1
                        ],
                        opacity: [0, 1]
                    }}
                    transition={{
                        duration: 0.8,
                        type: 'spring'
                    }}
                 className='img-g mt-6 md:mt-0   basis-[100%] md:basis-[50%] max-w-[50%]'>

                    <Swiper
                        modules={[
                            Navigation,
                            Autoplay,
                            Pagination
                        ]}
                        slidesPerView={1}
                        spaceBetween={20}
                        loop={true}
                        grabCursor={true}
                        autoplay={{
                          delay: 2000,
                          pauseOnMouseEnter: true,
                          disableOnInteraction: false
                        }}
                        breakpoints={{
                          756:{
                              slidesPerView: 3
                          },
                          576: {
                            slidesPerView: 2,
                          },
                          376: {
                            slidesPerView: 1
                          }
                        }}
                        className="w-full"
                        
                        

                       >

                        {
                            galleryimages.map((image, index) => (

                                <SwiperSlide key={`gallery_image-${index + 1}`} className="relative flex justify-center items-center group w-full">

                                    <img src={image} alt="" className='h-64 object-cover hover:opacity-90 rounded-md duration-200 '/>
                                    <BsInstagram className='absolute opacity-50 group-hover:opacity-100 duration-200 z-20 '/>

                                </SwiperSlide>

                            ))
                        }
                    </Swiper>

                </motion.div>
            </motion.div>

        </div>
    )

}

export default Gallery;
